import React, { Component } from "react";

import { Wrapper, Row, Button, Icon, Copy } from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";
import { dismissMobileKeyboard } from "app/NativeActions";

class BottomButtons extends Component {
  renderHashTagButton() {
    return (
      <Button
        style={{ marginRight: 10 }}
        onPress={() => {
          this.props.updateMessageProp({
            prop: "mention_tracker",
            value: !this.props.mention_tracker
          });
          this.props.updateMessageProp({
            prop: "show_brackets",
            value: false
          });
        }}
        tooltip={"Add Saved Reply"}
        tooltipPlacement={"top"}
      >
        <Icon
          fa_icon={"hashtag"}
          color={this.props.colors.light_text_color}
          size={22}
        />
      </Button>
    );
  }

  renderBracketsButton() {
    return (
      <Button
        style={{ marginRight: 10 }}
        onPress={() => {
          this.props.updateMessageProp({
            prop: "show_brackets",
            value: !this.props.show_brackets
          });

          this.props.updateMessageProp({
            prop: "mention_tracker",
            value: false
          });
        }}
        tooltip={"Lead Variables"}
        tooltipPlacement={"top"}
      >
        <Icon
          icon={"code"}
          color={this.props.colors.light_text_color}
          size={22}
        />
      </Button>
    );
  }

  renderImageButton() {
    return (
      <Button
        style={{ marginRight: 10 }}
        onPress={() => {}}
        tooltip={"Upload Image"}
        tooltipPlacement={"top"}
      >
        <Icon
          icon={"insert-photo"}
          color={this.props.colors.light_text_color}
          size={22}
        />
      </Button>
    );
  }

  renderGifButton() {
    return (
      <Button
        style={{ marginRight: 10 }}
        onPress={() => {}}
        tooltip={"Add Gif"}
        tooltipPlacement={"top"}
      >
        <Icon
          icon={"gif"}
          color={this.props.colors.light_text_color}
          size={22}
        />
      </Button>
    );
  }
  renderSendMessageButton() {
    if (!this.props.disabled) {
      return (
        <PillButton
          innerStyle={{
            paddingTop: 3,
            paddingBottom: 3,
            paddingLeft: 10,
            paddingRight: 10
          }}
          primary={true}
          onPress={() => {
            dismissMobileKeyboard();

            this.props.onSubmit({
              message: this.props.message,
              selected_from_number: this.props.selected_from_number,
              onSuccess: () => {
                this.props.updateMessageProp({
                  prop: "message",
                  value: ""
                });
                this.props.updateMessageProp({
                  prop: "show_save_reply",
                  value: false
                });
              }
            });
          }}
        >
          Send Message
        </PillButton>
      );
    }
  }

  renderSaveReplyButton() {
    if (
      this.props.show_save_reply &&
      this.props.message.length > 0 &&
      !this.props.multisend
    ) {
      return (
        <Button
          style={{
            paddingTop: 3,
            paddingBottom: 3,
            paddingLeft: 10,
            paddingRight: 10,
            borderRadius: 15,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: this.props.colors.border_color
          }}
          onPress={() => {
            this.props.setEditModal({
              title: "Create Saved Reply",
              description: "Create a reply to be used in other conversations.",
              slug: "create-saved-reply",
              type: "create_saved_reply",
              fields: {
                response_text: this.props.message,
                starting_response: false
              },
              save_button_text: "Create Saved Reply",
              modalAction: ({ fields }) => {
                this.props.updateSavedResponse({
                  token: this.props.token,
                  type: "create_saved_response",
                  response_text: fields.response_text,
                  starting_response: fields.starting_response,
                  onSuccess: () => {
                    this.props.appRedirect({
                      redirect: "goBack",
                      payload: { remove: "create-saved-reply" }
                    });

                    this.props.updateMessageProp({
                      prop: "message",
                      value: fields.response_text
                    });
                    this.props.updateMessageProp({
                      prop: "show_save_reply",
                      value: false
                    });
                  }
                });
              },
              always_save: true,
              cancelAction: () => {},
              fieldsUpdated: fields => {}
            });
            this.props.appRedirect({
              redirect: "goForward",
              payload: { add: "create-saved-reply" }
            });
          }}
        >
          <Copy>Save Reply</Copy>
        </Button>
      );
    }
  }

  render() {
    return (
      <Row
        style={{
          padding: 15,
          paddingTop: 10,
          paddingBottom: 10
        }}
      >
        <Row>
          {this.renderHashTagButton()}
          {this.renderBracketsButton()}
          {/*this.renderImageButton()*/}
          {/*this.renderGifButton()*/}
          {this.renderSaveReplyButton()}
        </Row>
        <Wrapper style={{ flex: 1 }} />
        {this.renderSendMessageButton()}
      </Row>
    );
  }
}

export default BottomButtons;
